module.exports = __webpack_public_path__ + "static/colophon-eb3ef3ba104cc2ec84e44d44c3b8c0a7.jpg";